module.exports = __webpack_public_path__ + "static/media/sort.959851c1.svg";